import { useGetCurfewsQuery } from "@/app/api/slices/curfewsApiSlice";
import { WhiteBox } from "@/components/WhiteBox";
import { useAuth } from "@/hooks/useAuth";
import { useCurrentVesselId } from "@/hooks/useCurrentVesselId";
import { useMemo } from "react";
import { CurfewPlanner } from "./curfew-planner";

export const CurfewsSettings = () => {
	const auth = useAuth();
	const role = auth?.user?.role.name || "";
	const vesselId = useCurrentVesselId();

	const {
		data: curfewsResponse,
		isLoading: isLoadingCurfews,
		isFetching: isFetchingCurfews,
	} = useGetCurfewsQuery({ vesselId });

	const sortedCurfews = useMemo(() => {
		if (!curfewsResponse?.data) return [];

		return [...curfewsResponse.data]
			.map((curfew) => ({
				...curfew,
				dateTime: new Date(`${curfew.date}T${curfew.time}`),
			}))
			.sort((a, b) => a.dateTime.getTime() - b.dateTime.getTime());
	}, [curfewsResponse]);

	if (!["manager", "fleet_manager"].includes(role)) return null;

	return (
		<WhiteBox className="mt-4">
			<h2 className="mt-4 mb-4 text-xl font-semibold sm:mt-0 md:text-2xl">Curfew Planner</h2>
			<div className="mb-2 max-w-[620px]">
				<CurfewPlanner
					curfews={curfewsResponse?.data ? sortedCurfews : []}
					isLoading={isLoadingCurfews || isFetchingCurfews}
				/>
			</div>
		</WhiteBox>
	);
};
